import { ApplicationState } from "@/store";
import { useMemo } from "react";
import { useSelector } from "react-redux";

export const useFilterState = () => {
  const selectFilter = (state: ApplicationState) => {
    return state.filterStateGenerateTerm;
  };

  const filterState = useSelector(selectFilter);

  return useMemo(() => filterState, [filterState]);
};